export default __webpack_public_path__ + "static/media/_logo_card_american-express.aea1560f.svg";